import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface DataErrorProps {
  error: string;
}

const DataErrorComponent: React.FC<DataErrorProps> = ({ error }) => (
  <div className="data-error-component-container">
    <ErrorOutlineIcon className="data-error-component-items" />
    {error}
  </div>
);

export default DataErrorComponent;
